import MTooltip from "./MTooltip.vue";
export default MTooltip;
